<template>
  <div>
    <v-dialog
    v-model='dialog'
    :fullscreen="!newPairingFlow || selectedTab === 1"
    :max-width="modalMaxWidth"
    :hide-overlay="!newPairingFlow"
    persistent
    scrollable
    :no-click-animation="!newPairingFlow"
    v-if="selectedTab >= 0">
      <v-card>
        <v-toolbar dark flat color='primary' style="max-height:64px">
          <v-toolbar-title>{{modalTitle}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click='closeModel'>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
         <v-card-text>
           <v-container fluid fill-height style="min-height:500px">
              <div style='margin-left:auto;margin-right:auto;margin-top:50px;' v-if="!newPairingFlow">
                <v-row >
                  <v-col cols='12' xs='12' sm='4' md='4' lg='4' align='center'>
                    <div ><v-img :src='profilePicture' class='profile-pic' width='130px' height='130px' ></v-img></div>
                  </v-col>
                  <v-col cols='12' xs='12' sm='8' md='8' lg='8' class='d-none d-sm-flex' >
                    <div style='margin-left: 40px;margin-bottom:50px;'>
                      <span style='font-size:30px;font-weight:300'>{{`${influencer.userHandle}`}}</span><br/><br/>
                      <span>{{`${influencer.followers} followers`}}</span>
                      <span style='margin-left: 20px;'>{{`${influencer.audience_credibility} AC`}}</span>
                      <span style='margin-left: 20px;'>{{`${influencer.engagement_rate} ER`}}</span><br/><br/>
                      <span style='font-size:18px;font-weight:500'>{{fullName}}</span><br/><br/>
                      <span >
                      <!-- First Check status Accepted  -->
                      <div v-if="influencer.status === this.pairingStatus.ACCEPTED.value">

                        <!-- Check Agreement available in object -->
                        <div v-if="influencer.agreement">
                          <!-- agreement is available in object and look for isAgree -->
                          <div  v-if="influencer.agreement.isAgree !== undefined">
                            <!-- Agreement and isAgree is available in object. Check Agreed or Declined -->
                            <v-chip v-if="influencer.agreement.isAgree" color="success" small dark>
                              Agreed
                            </v-chip>
                            <v-chip v-else color="red" small dark>
                              Declined
                            </v-chip>
                          </div>
                          <!-- agreement is available in object but isAgree is not avaible than show below chip -->
                          <v-chip v-else :color="getStatusColor(influencer.status)" small dark>
                            {{ influencer.status_description }}
                          </v-chip>
                        </div>
                        <!-- Agreement not available in object than show below chip -->
                        <v-chip v-else :color="getStatusColor(influencer.status)" small dark>
                          {{ influencer.status_description }}
                        </v-chip>
                      </div>
                      <!-- If not Accepted Status than show below chip -->
                      <v-chip v-else :color="getStatusColor(influencer.status)" small dark>
                          {{ influencer.status_description }}
                        </v-chip>
                      </span>
                    </div>
                  </v-col>
                  <!-- Only show on xs screen -->
                  <v-col cols='12' sm='12' md='12' class='d-flex d-sm-none' align='center' >
                    <div style='margin-left: 40px;margin-bottom:50px;width:100%;'>
                      <span style='font-size:30px;font-weight:300'>{{`${influencer.userHandle}`}}</span><br/><br/>
                      <span>{{`${influencer.followers} followers`}}</span>
                      <span style='margin-left: 20px;'>{{`${influencer.audience_credibility} AC`}}</span>
                      <span style='margin-left: 20px;'>{{`${influencer.engagement_rate} ER`}}</span><br/><br/>
                      <span style='font-size:18px;font-weight:500'>{{fullName}}</span><br/><br/>
                      <span >
                        <v-chip :color='getStatusColor(influencer.status)' small dark>
                          {{ influencer.status_description }}
                        </v-chip>
                      </span>
                    </div>
                  </v-col>
                </v-row>
                <!-- Action Buttons -->
                <div v-show='!pendingStatus && !acceptedStatus && !notAcceptedStatus' style='text-align:center;'>
                  <v-btn @click='approvedClick()' class='ma-2' tile color='success'>
                    <v-icon left>mdi-check</v-icon>Accepted
                  </v-btn>
                  <v-btn v-show='!notAcceptedStatus' @click="notAccepted()" class='ma-2' tile color='red'>
                    <v-icon left>mdi-cancel</v-icon>Not Accepted
                  </v-btn>
                  <!-- <v-btn v-show='inquiryStatus' class='ma-2' tile color='info'>
                    <v-icon left>mdi-help</v-icon>Inquiry
                  </v-btn> -->
                  <v-btn v-show='notInterestedStatus' class='ma-2' tile color='primary'>
                    Convince<v-icon right>mdi-help</v-icon>
                  </v-btn>
                </div>
                <div v-show='pendingStatus' style='text-align:center;' >
                  <v-btn class='ma-2' tile color='success' @click='approvedClick()'>
                    <v-icon left>mdi-check</v-icon>Accepted
                  </v-btn>
                  <v-btn v-show='!notAcceptedStatus' @click="notAccepted()" class='ma-2' tile color='red'>
                    <v-icon left>mdi-cancel</v-icon>Not Accepted
                  </v-btn>
                  <v-btn class='ma-2' tile color='primary' @click='followUp()'>
                    Follow Up<v-icon right>mdi-help</v-icon>
                  </v-btn>
                </div>
              </div>
              <hr width='90%' style='margin-left: auto;margin-right: auto;' v-if="!newPairingFlow"/>
              <!-- Tabs -->
              <v-tabs
                centered
                v-model='selectedTab'
                v-show="tabShow"
              >
                <v-tabs-slider></v-tabs-slider>
                <v-tab v-show="!newPairingFlow">
                  Detail
                </v-tab>
                <v-tab v-if='inquiryStatus' >
                  Q&A
                </v-tab>
                <v-tab v-if='notInterestedStatus'>
                  Reject reasons
                </v-tab>
                <v-tab v-show='(interestedStatus || pendingStatus || acceptedStatus) && !newPairingFlow'>
                  Brief detail
                </v-tab>
                <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <v-row justify="center" align="start">
                      <v-col cols='12' sm='12' :md='newPairingFlow?12:6' :lg='newPairingFlow?12:6' >
                        <v-card >
                          <v-card-title>Campaign</v-card-title>
                          <v-card-text>
                            {{`${influencer.CampaignName}`}}
                            <v-divider></v-divider>
                            <div v-show='this.influencer.deliverables'>
                            <h4>Deliverables</h4>
                            <lu>
                              <li v-show='numberOfTikTokPost > 0'><strong>{{numberOfTikTokPost}}</strong> x TikTok Post</li>
                              <li v-show='numberOfXHSPost > 0'><strong>{{numberOfXHSPost}}</strong> x XHS Post</li>
                              <li v-show='numberOfPost > 0'><strong>{{numberOfPost}}</strong> x Instagram Post</li>
                              <li v-show='numberOfCarousels > 0'><strong>{{numberOfCarousels}}</strong> x Instagram Carousels Post</li>
                              <li v-show='numberOfStories > 0'><strong>{{numberOfStories}}</strong> x Instagram Stories</li>
                              <li v-show='numberOfVideo > 0'><strong>{{numberOfVideo}}</strong> x Instagram Video</li>
                              <li v-show='numberOfIGReels > 0'><strong>{{numberOfIGReels}}</strong> x Instagram Reel</li>
                              <li v-show='numberOfLinkedInPosts > 0'><strong>{{numberOfLinkedInPosts}}</strong> x LinkedIn Post</li>
                              <li v-show='numberOfXPosts > 0'><strong>{{numberOfXPosts}}</strong> x X (Twitter) Post</li>
                              <li v-show='numberOfYoutube > 0'><strong>{{numberOfYoutube}}</strong> x Youtube</li>
                              <li v-if='isLoadingWhitelist'><strong>{{influencer.deliverables.loading_whitelisting}}</strong> x Loading/Whitelisting</li>
                              <li v-if='isExclusivity'><strong>{{influencer.deliverables.exclusivity}}</strong> x Exclusivity</li>
                              <li v-show='numberOfPA > 0'><strong>{{numberOfPA}}</strong> x Physical Attendance</li>
                              <li v-show='numberOfOA > 0'><strong>{{numberOfOA}}</strong> x Online Attendance</li>
                            </lu>
                            <div class="clearfix">
                              <div v-if="influencer.deliverables">
                                <v-list class="pt-0 pb-0" v-for="(custom, pIndex) in influencer.deliverables.custom" :key="pIndex">
                                  <!-- <div class="delete-sm text-right pt-3">
                                    <v-btn
                                      color="danger"
                                      @click="influencerData[field.name].splice(pIndex, 1)"
                                      text
                                      x-small
                                      v-if="!viewMode">
                                      <v-icon color="red">mdi-delete-forever</v-icon>
                                    </v-btn>
                                  </div> -->
                                  <v-list-item class="multiple-fields-area pt-0 pb-0">
                                    <div class="d-flex flex-row pt-2">
                                        <div>
                                          <v-text-field
                                            class="mutliple-field px-1"
                                            dense
                                            outlined
                                            hide-details
                                            placeholder="Custom Deliverables"
                                            v-model="custom.label">
                                          </v-text-field>
                                        </div>
                                        <v-text-field
                                          type="number"
                                          dense
                                          outlined
                                          hide-details
                                          v-model.number="custom.value"
                                          min="1">
                                        </v-text-field>
                                        <v-btn
                                          class="pt-5"
                                          color="danger"
                                          @click="influencer.deliverables.custom.splice(pIndex, 1)"
                                          text
                                          x-small>
                                          <v-icon color="red">mdi-delete-forever</v-icon>
                                        </v-btn>
                                      </div>
                                  </v-list-item>
                                </v-list>
                              </div>
                              <v-list class="float-left">
                                <v-list-item style="margin-top: -5px">
                                  <v-btn
                                  small
                                  color="secondary"
                                  @click="addCustom()">
                                  <v-icon small>mdi-plus</v-icon> Add Custom Deliverable
                                  </v-btn>
                                </v-list-item>
                              </v-list>
                            </div>
                            <v-divider></v-divider>
                            <!-- Boosting Fees Section -->
                            <h4>Additional Line Items</h4>
                            <div class="clearfix" v-if="influencer.payout_details">
                              <div v-if="influencer.payout_details.boostingFees">
                                <v-list class="pt-0 pb-0" v-for="(boostingFee, bIndex) in influencer.payout_details.boostingFees" :key="bIndex">
                                  <v-list-item class="multiple-fields-area pt-0 pb-0">
                                    <div class="d-flex flex-row pt-2">
                                        <div>
                                          <v-text-field
                                            class="mutliple-field px-1"
                                            dense
                                            outlined
                                            hide-details
                                            placeholder="E.g. Boosting Fee"
                                            v-model="boostingFee.label">
                                          </v-text-field>
                                        </div>
                                        <v-text-field
                                          type="number"
                                          dense
                                          outlined
                                          hide-details
                                          v-model.number="boostingFee.value"
                                          min="0"
                                          step="0.01"
                                          @input="updateTotalPayoutWithBoostingFee(boostingFee.value)">
                                        </v-text-field>
                                        <v-btn
                                          class="pt-5"
                                          color="danger"
                                          @click="deleteBoostingFees(bIndex)"
                                          text
                                          x-small>
                                          <v-icon color="red">mdi-delete-forever</v-icon>
                                        </v-btn>
                                      </div>
                                  </v-list-item>
                                </v-list>
                              </div>
                              <v-list class="float-left">
                                <v-list-item style="margin-top: -5px">
                                  <v-btn
                                  small
                                  color="secondary"
                                  @click="addBoostingFee()">
                                  <v-icon small>mdi-plus</v-icon> Add Additional Line Item
                                  </v-btn>
                                </v-list-item>
                              </v-list>
                            </div>
                            <!-- <lu v-if='numberOfCustoms && numberOfCustoms.length > 0'>
                              <li v-for="(custom, index) in influencer.deliverables.custom" :key="index" v-show="custom.label">
                                <strong>{{custom.value}}</strong> x {{custom.label}}
                              </li>
                            </lu> -->
                            <ul class="pa-0">
                              <li class="mt-2" style="list-style:none;">
                                <v-textarea
                                  hide-details
                                  v-model="deliverableNotes"
                                  dense
                                  outlined
                                  style="width:100%"
                                ></v-textarea>
                              </li>
                            </ul>
                            <v-divider></v-divider>
                            </div>
                             <h4>Payout Amount</h4>
                             <!-- <span v-if="GST" style='font-size:30px;font-weight:400;color:green;'>{{formatPayout(influencer.payout + (influencer.payout * 0.07))}}</span> -->
                             <div class="d-flex">
                              <v-combobox
                                style="max-width:100px;font-size:20px"
                                v-model="currency"
                                :items="currencies"
                                outlined
                                dense
                              ></v-combobox>
                              <span style='font-size:30px;font-weight:400;color:green;padding-top:7px;padding-left:10px'>{{totalPayout}}</span>
                            </div>
                             <v-divider></v-divider>
                             <container>
                               <v-card outlined>
                                  <v-card-text>
                                    <h4>Submission Date</h4>
                                      <v-row>
                                          <v-col cols="12" >
                                            <v-menu
                                              v-model="menu"
                                              :close-on-content-click="false"
                                              max-width="290"
                                            >
                                              <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                  :value="submissionDateFormatted"
                                                  label=""
                                                  prepend-icon="mdi-calendar"
                                                  hint="DD/MM/YYYY format"
                                                  readonly
                                                  v-bind="attrs"
                                                  v-on="on"
                                                ></v-text-field>
                                              </template>
                                              <v-date-picker
                                                v-model="submissionDate"
                                                @change="menu = false"
                                              >
                                              </v-date-picker>
                                            </v-menu>
                                          </v-col>
                                      </v-row>
                                      <!-- <h4>Live Date</h4>
                                      <v-row>
                                          <v-col cols="12" >
                                            <v-menu
                                              v-model="livedate_menu"
                                              :close-on-content-click="false"
                                             max-width="290"
                                            >
                                              <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                  :value="liveDateFormatted"
                                                  label=""
                                                  prepend-icon="mdi-calendar"
                                                  hint="DD/MM/YYYY format"
                                                  readonly
                                                  v-bind="attrs"
                                                  v-on="on"
                                                ></v-text-field>
                                              </template>
                                              <v-date-picker
                                                v-model="liveDate"
                                                @change="livedate_menu = false"
                                              >
                                              </v-date-picker>
                                            </v-menu>
                                          </v-col>
                                      </v-row> -->
                                      <v-row>
                                        <v-col cols="12">
                                            <v-checkbox
                                              v-model="chkGST"
                                              hide-details
                                              label="Include GST 9%"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                      </v-row>
                                      <v-row class="mt-0 pt-0">
                                        <v-col cols="12" class="mt-0 pt-0">
                                            <v-checkbox
                                              v-model="chkSpecialPaymentTerms"
                                              hide-details
                                              label="Special Payment Terms"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                      </v-row>
                                  </v-card-text>
                               </v-card>
                               <v-card class="mt-5" outlined>
                                  <v-card-text>
                                    <h4>Remarks</h4>
                                      <v-row>
                                          <v-col cols="12" >
                                            <v-textarea
                                              hide-details
                                              v-model="invoiceRemarks"
                                              dense
                                              outlined
                                              style="width:100%"
                                            ></v-textarea>
                                          </v-col>
                                      </v-row>
                                  </v-card-text>
                               </v-card>
                            </container>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols='12' sm='12' md='6' lg='6' v-show="campaignBackground">
                        <v-card>
                          <v-card-title>Campaign Background</v-card-title>
                          <v-card-text>
                            <p style="white-space: pre-wrap;">{{campaignBackground}}</p>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <!-- <v-col cols='12' sm='12' md='6' lg='6'>
                        <v-card>
                          <v-card-title>Content Angle</v-card-title>
                          <v-card-text v-for='(item, index) in filterContentItems' :key='index'>
                          <h4>{{item.option_name}}</h4>
                          <v-row>
                            <v-col>
                              Required action<br/>
                              <strong>{{item.required_action}}</strong>
                            </v-col>
                            <v-col>
                              Image angle<br/>
                              <strong>{{item.image_angle}}</strong>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              Content angle<br/>
                              <strong>{{item.content_angle}}</strong>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              Image inspiration<br/><br/>
                              <v-row>
                                <v-col>
                                 <div style='float:left;margin-right:10px;margin:5px;' v-for='(image, index) in item.sample_images' :key='index'>
                                    <v-img cover
                                      max-height='150'
                                      max-width='250'
                                      :src='`https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/${image}`'
                                      >
                                    </v-img>
                                 </div>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col> -->
                    </v-row>
                  </v-card-text>
                </v-card>
                </v-tab-item>
                <v-tab-item v-if='inquiryStatus'>
                  <v-card flat>
                    <v-card-text>
                      <QandA :Questions='loadAllQuestions' :campaignID='influencer.CampaignID' :influencerID='influencer.influencer_details.influencerID' :TriggerEmail='true' :pairedID='influencer.id' />
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item v-if='notInterestedStatus'>
                  <v-card style='width:600px;margin-left:auto;margin-right:auto;margin-top:50px;margin-bottom:20px;'>
                    <v-card-title>Reasons</v-card-title>
                    <v-card-text>
                      <div>
                      <ul v-if='rejectReasons' style='font-size:20px;font-weight:300;'>
                        <li v-if='rejectReasons.campaign_proposed'>{{rejectReasons.campaign_proposed}}</li>
                        <li v-if='rejectReasons.campaign_timeline'>{{rejectReasons.campaign_timeline}}</li>
                        <li v-if='rejectReasons.payout_issue'>{{rejectReasons.payout_issue}}</li>
                        <li v-if='rejectReasons.competitor'>{{rejectReasons.competitor}}</li>
                        <li v-if='rejectReasons.not_associate'>{{rejectReasons.not_associate}}</li>
                        <li v-if='rejectReasons.others'>{{rejectReasons.others}}</li>
                        <li v-if='rejectReasons.co_reject'>{{rejectReasons.co_reject}}</li>
                      </ul>
                    </div>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <!-- Vue Rich Editor -->
                <v-tab-item>
                  <!-- <v-container> -->
                    <v-row>
                      <v-col cols='12'>
                        <v-row class="row">
                          <v-col class="text-right" cols='12'>
                            <v-btn class="ma-1" color='primary' width='200' @click='restoreCampaignBrief'>Reset as Campaign Brief</v-btn>
                          </v-col>
                        </v-row>
                        <!-- <vue2-editor
                        style='height:650px;'
                        :content='briefDetailContent'
                        :editorOpened="editorOpened"
                        @contentChanged="changeBriefContent"
                        @changeEditorOpened="changeEditorOpen"
                        @contentChangeFocus="focusBriefContent"
                        @loadingDialogOpen="loadingDialogOpen"
                        @loadingDialogClose="loadingDialogClose">
                        </vue2-editor> -->
                        <sun-editor
                        style='height:650px;'
                        width="100%"
                        :content='briefDetailContentNew'
                        :editorOpened="editorOpened"
                        @contentChanged="changeBriefContent"
                        @loadingDialogOpen="loadingDialogOpen"
                        @loadingDialogClose="loadingDialogClose"
                        source="brief">
                        </sun-editor>
                        <!-- <editor
                        :reportName="reportName"
                        :influencerName="influencerContract.influencer_details ? influencerContract.influencer_details.userHandle : ''"
                        :content="briefDetailContent"
                        :pairingID="influencer.id"
                        :userID="currentUser.id"
                        :saveStatus="briefSaveStatusId"
                        @reloadDataTable="reloadDataTable"
                        @contentChangeTrue="contentChangeTrue"
                        @contentChangeFalse="contentChangeFalse"
                        @closeModal="closeModel"
                        >
                        </editor> -->
                      </v-col>
                    </v-row>
                    <!-- <v-row style='margin-top:50px;text-align:right;'>
                      <v-col cols='12'>
                        <v-btn color='primary' width='200' @click='briefDetailSave'>Save</v-btn>
                      </v-col>
                    </v-row> -->
                  <!-- </v-container> -->
                  <v-container>
                    <v-row class="editor-row">
                      <v-col cols='12'>
                        <v-btn
                        :loading="loading"
                        :disabled="loading"
                        color="blue-grey"
                        class="ma-1 white--text"
                        @click='download'
                        >Download
                        <v-icon right dark>mdi-cloud-download</v-icon>
                        </v-btn>
                        <v-btn class="ma-1" color='primary' width='200' @click='briefDetailSave'>Save</v-btn>
                        <v-btn class="ma-1" right @click="closeModel">
                        Close
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
                <v-tab-item v-if="acceptedStatus">
                  <v-container style="max-width:850px;">
                    <div style="margin-top:50px;margin-left:auto,margin-right:auto;" v-html="this.briefDetail"></div>
                  </v-container>
                </v-tab-item>
              </v-tabs>
          </v-container>
         </v-card-text>
          <v-card-actions v-if="selectedTab === 0">
            <v-row style="margin-bottom:10px !important;">
              <v-col cols="12" align="right" style="margin-right:20px">
                <v-container>
                  <div>
                    <v-btn
                      color="secondary"
                      @click="updateSubmission"
                    >
                      Save
                    </v-btn>
                    <v-btn class="mr-2" right @click="close">
                    Close
                    </v-btn>
                  </div>
                </v-container>
              </v-col>
            </v-row>
          </v-card-actions>
      </v-card>
        <v-snackbar v-model="snackbar" color="success" rounded="pill" :timeout="snackbarTimeout">
          {{snackbarText}}
          <template v-slot:action="{ snackattrs }">
            <v-btn
              color="white"
              text
              v-bind="snackattrs"
              @click="snackbar = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
    </v-dialog>
    <influencer-contract-modal
    dialogTitle='Invoice'
    :dialog='showContractModal'
    :close='closeInfluencerContractModal'
    :contract='influencerContract'
    :invoiceContract='invoiceContract'
    :action='upatedApproved'
    :showTerms = 'false'
    :showSendButton = 'true'
    :showSubmitButton = 'false'
    :showDeclineButton = 'false'
    :showOptions = 'false'
    :showCancelButton = 'true'
    :emailTemplateHTML ='emailTemplateHTML'
    :updateEmailTemplate='updateEmailTemplate'
    :content='this.briefDetailContent'
    :briefDetailHTML='this.briefDetail'
    :users="influencer.Users || []"
    :selectedUser="selectedUser"
    :influencerEmail="influencerEmail" />
    <follow-up
    :dialog='showFollowUpModal'
    :dialogClose='followUpClose'
    :from='currentUser.email'
    :fromName= 'currentUserFullName'
    :to='currentInfluencerEmail'
    :toName='fullName'/>

    <v-snackbar v-model="snackbar" color="success" rounded="pill" :timeout="snackbarTimeout">
      {{snackbarText}}
      <template v-slot:action="{ snackattrs }">
        <v-btn
          color="white"
          text
          v-bind="snackattrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<style scoped>
  .profile-pic {
    border-radius: 50%;
  }
</style>
<style>
  .v-label {
    margin-bottom: 0px !important;
    font-weight: normal !important;
  }
</style>
<script>
/* eslint-disable */
import moment from 'moment'
import influencerContractTemplate from '../../Contract/Influencer_contract'
// import influencerInvoiceTemplate from '../../Contract/Influencer_invoice'
import utils from '../../../../utils'
import QandA from '../CampaignInvite/QandA'
import config from '@/config'
import pairingAPIs from '../../Pairing/pairingAPIs'
import InfluencerContractModal from '../CampaignInvite/InfluencerContractModal'
import { mapGetters } from 'vuex'
import campaignHelper from '../campaignHelper';
// import { VueEditor } from 'vue2-editor'
import Vue2Editor from '../../../editor/vue2Editor'
import SunEditor from '../../../editor/sunEditor'
import editor from '../../../editor/editorjs'
// import BlocksToPDF from '../../../editor/generator/blocksToPDF'
import HTMLToPDF from '../../../editor/generator/HTMLToPDF'
import BlocksToHtml from '../../../editor/generator/blocksToHtml'
// import postApi from '../../Post/postApi'
import FollowUp from './followUp'
import mustache from 'mustache'
import * as pdfMake from 'pdfmake/build/pdfmake.js';
// import * as pdfFonts from '../../Campaign/custom-fonts';
// const vfs = pdfFonts.pdfMake.vfs;
// setTimeout(() => {
//   pdfMake.vfs = vfs
// }, 100)

export default {
  name: 'Invoices-Brief-Dialog',
  props: ['dialog', 'influencer', 'influencerProfile', 'close', 'loadAllQuestions', 'selectedTab', 'briefDetailContent', 'newPairingFlow', 'isDownload', 'isFinalPayout', 'isGetInvoice'],
  components: {
    QandA,
    InfluencerContractModal,
    Vue2Editor,
    SunEditor,
    editor,
    FollowUp
  },
  data () {
    return {
      showContractModal: false,
      showAmountRowSpan: '',
      influencerContract: {},
      invoiceContract: {},
      rowSpanCount: 0,
      editorContentChange: false,
      submissionDate: '',
      menu: false,
      livedate_menu: false,
      liveDate: '',
      deliverableNotes: '',
      invoiceRemarks: '',
      snackbar: false,
      snackbarTimeout: 2000,
      snackbarText: '',
      showFollowUpModal: false,
      chkGST: false,
      chkSpecialPaymentTerms: false,
      currentPayout: 0,
      totalPayout: 0,
      oldPayoutDetails: [],
      emailTemplateHTML: '',
      emailTemplateView: {
        influencer_name: '',
        submission_date: '',
        live_date: '',
        co_email: ''
      },
      briefSaveStatusId: 1,
      selectedUser: '',
      influencerEmail: '',
      contractFile: '',
      defaultMsg: 'Server Error',
      tabShow: false,
      editorOpened: false,
      loader: null,
      loading: false,
      downloadloading: false,
      currencies: config.currencies,
      currency: 'SGD',
      briefDetailContentNew: ''
    }
  },
  watch: {
    async watchInfluencer(val, oval) {
      this.briefDetailContentNew = this.briefDetailContent
      this.close()
      this.submissionDate = ''
      this.liveDate = ''
      this.chkGST = false
      this.editorOpened = true
      this.showAmountRowSpan = ''
      this.currency = 'SGD'
      this.contentChangeFalse()
      if (val.pairing_details.submission_date) {
        this.submissionDate = new Date(val.pairing_details.submission_date).toISOString().substr(0, 10);
      }

      if (val.pairing_details.live_date) {
        this.liveDate = new Date(val.pairing_details.live_date).toISOString().substr(0, 10)
      }
      this.chkGST = val.pairing_details.GST
      this.chkSpecialPaymentTerms = val.pairing_details.SpecialPaymentTerms
      this.deliverableNotes = val.pairing_details.deliverable_notes || ''
      this.invoiceRemarks = val.pairing_details.remarks || ''
      this.currentPayout = val.payout
      this.totalPayout = val.payout
      // Always reset first - a newly selected influencer with no payout_details must not
      // inherit oldPayoutDetails left over from whichever influencer was open previously.
      this.oldPayoutDetails = {}
      if (val.payout_details) {
        this.currency = val.payout_details.currency || 'SGD'
        if (!Array.isArray(val.payout_details.boostingFees)) {
          this.$set(val.payout_details, 'boostingFees', [])
        }
        this.oldPayoutDetails = Object.assign({}, JSON.parse(JSON.stringify(val.payout_details)))
      }

      let emailTemplate = '<p>Hello <b>{{influencer_name}}</b>,</p>\nStoked to have you on board for this campaign Charmaine! We have scheduled delivery to your mailing address tomorrow.<br/><p>Date of Submission: <b>{{submission_date}}</b></p><br/><p>You will find 2 documents attached below:\nInvoice\nCampaign Brief Document</p><br/><p>It is important to read through the campaign brief before executing your campaign, do ensure you take backup photos to avoid any possible reshoots or revisions to save you time and effort.</p><br/><p>Do you have any questions about the campaign brief or the submission date?\nYou can reach me at <b>{{co_email}}</b> for any urgent matters, Looking forward to your seeing your content!</p><br/>Cheers'
      this.emailTemplateView.influencer_name = val.influencer_details.fullname
      this.emailTemplateView.submission_date = moment(this.submissionDate).format('DD/MM/yyyy')
      // this.emailTemplateView.live_date = moment(this.liveDate).format('DD/MM/yyyy')
      this.emailTemplateView.co_email = this.currentUser.email
      // let view = {
      //   influencer_name: val.influencer_details.fullname,
      //   submission_date: moment(this.submissionDate).format('DD/MM/yyyy'),
      //   live_date: moment(this.liveDate).format('DD/MM/yyyy'),
      //   co_email: this.currentUser.email
      // }
      let html = mustache.render(emailTemplate, this.emailTemplateView)
      this.emailTemplateHTML = html
      let vm = this
      // if send invoice
      if (this.selectedTab === 2) {
        setTimeout(() => {
          vm.close()
          vm.approvedClick()
          setTimeout(() => {
            pdfMake.fonts = {
              Arial: {
                normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
                bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
              }
            }
          }, 1000);
        }, 100)
      }
      // for confirm payout function, process submit only
      if (this.isDownload) {
        this.close()
        let updatedSubmission = await this.updateSubmission(false)
        if (updatedSubmission) this.updateSend()
        // setTimeout(() => {
        //   this.close()
        //   console.log('this is for download')
        //   this.updateSend()
        // }, 1000);
      }
      // for get invoice function, generate invoice file only
      if (this.isGetInvoice) {
        this.close()
        if (await this.getInvoiceContract()) {
          this.$emit('generatedInvoice', this.contractFile)
        }
      }
      setTimeout(() => {
        vm.tabShow = true
      }, 500)
    },
    loader() {
      const l = this.loader
      this[l] = !this[l]
      this.loader = null
    }
  },
  computed: {
    ...mapGetters('pairing', {
      pairingStatus: 'status'
    }),
    currentUser() {
      return this.$store.state.user;
    },
    currentInfluencerEmail() {
      if (this.influencer) {
        return this.influencer.influencer_details.contact_details ? this.influencer.influencer_details.contact_details.email : ''
      }
    },
    currentUserFullName() {
      return `${this.$store.state.user.firstName} ${this.$store.state.user.lastName}`
    },
    profilePicture: function() {
      return (this.influencerProfile.profilePicture ? this.influencerProfile.profilePicture : '/static/img/avatar/user.png')
    },
    fullName: function() {
      if (this.influencer.influencer_details) {
        return this.influencer.influencer_details.fullname
      } else return null
    },
    numberOfTikTokPost: function() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.no_of_tiktok_posts
      } else return null
    },
    numberOfXHSPost: function() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.no_of_xhs_posts
      } else return null
    },
    numberOfPost: function() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.no_of_posts
      } else return null
    },
    numberOfCarousels: function() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.no_of_carousels
      } else return null
    },
    numberOfStories: function() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.no_of_stories
      } else return null
    },
    numberOfVideo: function() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.no_of_video
      } else return null
    },
    numberOfIGReels: function() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.no_of_reels
      } else return null
    },
    numberOfLinkedInPosts: function() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.no_of_li_posts
      } else return null
    },
    numberOfXPosts: function() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.no_of_x_posts
      } else return null
    },
    numberOfYoutube: function() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.youtube
      } else return null
    },
    isLoadingWhitelist: function() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.loading_whitelisting
      } else return null
    },
    isExclusivity: function() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.loading_whitelisting
      } else return null
    },
    numberOfPA: function() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.physical_attendance
      } else return null
    },
    numberOfOA: function() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.online_attendance
      } else return null
    },
    numberOfCustoms: function() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.custom || []
      } else return null
    },
    GST: function() {
      if (this.influencer.pairing_details.GST) {
        return this.influencer.pairing_details.GST
      }
    },
    campaignBackground: function() {
      if (this.influencer.campaign_brief_details) {
        if (this.influencer.campaign_brief_details.campaignBackground) {
          return this.influencer.campaign_brief_details.campaignBackground
        }
      }
    },
    interestedStatus: function() {
      if (this.influencer.status === this.pairingStatus.INTERESTED.value) {
        return true
      } else return false
    },
    notInterestedStatus: function() {
      if (this.influencer.status === this.pairingStatus.NOT_INTERESTED.value) {
        return true
      } else return false
    },
    inquiryStatus: function() {
      if (this.influencer.status === this.pairingStatus.INQUIRY.value) {
        return true
      } else return false
    },
    notAcceptedStatus: function() {
      if (this.influencer.status === this.pairingStatus.NOT_ACCEPTED.value) {
        return true
      } else return false
    },
    acceptedStatus: function() {
      if (this.influencer.status === this.pairingStatus.ACCEPTED.value) {
        return true
      } else return false
    },
    pendingStatus: function() {
      if (this.influencer.status === this.pairingStatus.INVITED.value) {
        return true
      } else return false
    },
    rejectReasons: function() {
      if (this.influencer.pairing_details.reject_reason) {
        return this.influencer.pairing_details.reject_reason
      } else return null
    },
    briefDetail: function() {
      if (this.briefDetailContent === undefined) {
        return ''
      }
      return this.briefDetailContent
      // const blocksToHtml = new BlocksToHTML(this.briefDetailContent.blocks)
      // let briefHtmlData = blocksToHtml.generate()
      // return briefHtmlData
    },
    getRowSpanCount() {
      this.rowSpanCount = 0
      if (this.influencerContract.deliverables.no_of_carousels > 0) this.rowSpanCount++
      if (this.influencerContract.deliverables.no_of_igTv > 0) this.rowSpanCount++
      if (this.influencerContract.deliverables.no_of_tiktok_posts > 0) this.rowSpanCount++
      if (this.influencerContract.deliverables.no_of_xhs_posts > 0) this.rowSpanCount++
      if (this.influencerContract.deliverables.no_of_fb_posts > 0) this.rowSpanCount++
      if (this.influencerContract.deliverables.no_of_posts > 0) this.rowSpanCount++
      if (this.influencerContract.deliverables.no_of_stories > 0) this.rowSpanCount++
      if (this.influencerContract.deliverables.no_of_video > 0) this.rowSpanCount++
      if (this.influencerContract.deliverables.no_of_reels > 0) this.rowSpanCount++
      if (this.influencerContract.deliverables.no_of_li_posts > 0) this.rowSpanCount++
      if (this.influencerContract.deliverables.no_of_x_posts > 0) this.rowSpanCount++
      if (this.influencerContract.deliverables.youtube > 0) this.rowSpanCount++
      if (this.influencerContract.deliverables.loading_whitelisting) this.rowSpanCount++
      if (this.influencerContract.deliverables.exclusivity) this.rowSpanCount++
      if (this.influencerContract.deliverables.physical_attendance) this.rowSpanCount++
      if (this.influencerContract.deliverables.online_attendance) this.rowSpanCount++
      if (this.influencerContract.deliverables.custom) this.rowSpanCount += this.influencerContract.deliverables.custom.length

      return this.rowSpanCount;
    },
    watchInfluencer() {
      return this.influencer
    },
    submissionDateFormatted() {
      return this.submissionDate ? moment(this.submissionDate).format('DD/MM/yyyy') : ''
    },
    liveDateFormatted() {
      return this.liveDate ? moment(this.liveDate).format('DD/MM/yyyy') : ''
    },
    filterContentItems() {
      if (this.influencer.contentAngles) {
        return this.influencer.contentAngles.slice(0, 1)
      } else return null
    },
    chkPayoutGST() {
      let payout = this.influencerContract.payout;
      
      // Subtract boosting fees if they exist
      if (this.influencerContract.payout_details && this.influencerContract.payout_details.boostingFees && Array.isArray(this.influencerContract.payout_details.boostingFees)) {
        for (let boostingFee of this.influencerContract.payout_details.boostingFees) {
          payout -= Number(boostingFee.value) || 0;
        }
      }
      
      // Apply GST adjustment if enabled
      if (this.influencerContract.GST) {
        return Number(payout - this.influencerContract.GSTpercent).toFixed(2);
      } else {
        return Number(payout).toFixed(2);
      }
    },
    modalMaxWidth() {
      if (this.newPairingFlow) {
        return this.selectedTab === 0 ? '700px' : '100%'
      }
      return '100%'
    },
    modalTitle() {
      if (this.newPairingFlow) {
        return this.selectedTab === 0 ? 'Edit Invoice & Contract' : 'Edit Creators Brief'
      }
      return 'Influencer Details'
    },
    reportName() {
      let reportName = ''
      reportName += this.influencer.CampaignName + '_'
      reportName += this.influencer.influencer_details ? this.influencer.influencer_details.userHandle + '_' : ''
      return reportName
    }
  },
  methods: {
    updateEmailTemplate(template) {
      let strReplace
      strReplace = template.toString().replace(/<p><br><\/p>/g, '')
      this.emailTemplateHTML = strReplace.toString().replace(/\n/g, '<br/>')
    },
    formatPayout(n) {
      let currency = 'SGD'
      if (this.influencerContract) {
        currency = this.influencerContract.currency || 'SGD'
      }
      if (!n) return n
      if (n.toString().indexOf('-') !== -1) {
        let str = n.toString().split('-')
        return currency + ' ' + parseFloat(str[0]) + ' - ' + str[1]
      } else {
        return currency + ' ' + parseFloat(n)
      }
    },
    getStatusColor(status) {
      if (status) {
        if (status === this.pairingStatus.INVITED.value) {
          return 'orange';
        } else if (status === this.pairingStatus.INTERESTED.value) {
          return '#81C784';
        } else if (status === this.pairingStatus.NOT_INTERESTED.value) {
          return 'red';
        } else if (status === this.pairingStatus.ACCEPTED.value) {
          return '#66BB6A';
        } else if (status === this.pairingStatus.NOT_ACCEPTED.value) {
          return 'red';
        } else if (status === this.pairingStatus.INQUIRY.value) {
          return '#1E88E5';
        } else return 'white';
      }
    },
    /**
     * This is for the contract data
     */
    async viewInvitation(campaign, influencer, type) {
      try {
        let invitation;
        if (type === 'tiktok') {
          invitation = await pairingAPIs.getInvitationTikTok(campaign, influencer);
        } else if (type === 'youtube') {
          invitation = await pairingAPIs.getInvitationYoutube(campaign, influencer);
        } else if (type === 'facebook') {
          invitation = await pairingAPIs.getInvitationFacebook(campaign, influencer);
        } else if (type === 'xiaohongshu') {
          invitation = await pairingAPIs.getInvitationXHS(campaign, influencer);
        } else if (type === 'others') {
          invitation = await pairingAPIs.getInvitationOthers(campaign, influencer);
        } else {
          invitation = await pairingAPIs.getInvitationbyIGHandle(campaign, influencer);
        }
        let contractDataObj = Object.assign({}, invitation)
        contractDataObj.campaignID = this.influencer.CampaignID
        // contractDataObj.influencer = this.influencer.influencer_details
        // console.log('Invitation', contractDataObj)
        this.influencerContract = contractDataObj
      } catch (error) {
        this.influencerContract.notInvoked = true
        const message = error ? error.response.data || this.defaultMsg : this.defaultMsg;
        if (message.includes('not invoked')) {
          this.$swal({
            type: 'error',
            text: 'Influencer Not Invited.'
          });
        }
      }
    },
    generateContract() {
      let tableBody = [];
      let contractTemplate = utils.func.refreshJSON(influencerContractTemplate)
      // Header Date
      contractTemplate.header.text = 'Date: ' + this.dateFormat(Date.now());
      contractTemplate.defaultStyle = {font: 'Arial'};
      // Content Creator Details
      if (this.influencerContract.influencer_details.platform === 'tiktok') {
        contractTemplate.content[2].table.body[1][0].text = 'TikTok Handle: ' + this.influencerContract.influencer_details.userHandle
      } else if (this.influencerContract.influencer_details.platform === 'instagram') {
        contractTemplate.content[2].table.body[1][0].text = 'Instagram Handle: ' + this.influencerContract.influencer_details.userHandle
      } else if (this.influencerContract.influencer_details.platform === 'youtube') {
        contractTemplate.content[2].table.body[1][0].text = 'Youtube Handle: ' + this.influencerContract.influencer_details.userHandle
      } else if (this.influencerContract.influencer_details.platform === 'facebook') {
        contractTemplate.content[2].table.body[1][0].text = 'Facebook Handle: ' + this.influencerContract.influencer_details.userHandle
      } else if (this.influencerContract.influencer_details.platform === 'twitter') {
        contractTemplate.content[2].table.body[1][0].text = 'X (Twitter) Handle: ' + this.influencerContract.influencer_details.userHandle
      } else if (this.influencerContract.influencer_details.platform === 'others') {
        contractTemplate.content[2].table.body[1][0].text = this.influencerContract.influencer_details.platformName + ' Handle: ' + this.influencerContract.influencer_details.userHandle
      } else {
        contractTemplate.content[2].table.body[1][0].text = 'Platform Handle: ' + this.influencerContract.influencer_details.userHandle
      }
      // contractTemplate.content[2].table.body[2][0].text = 'Full Name: ' + (this.influencerContract.influencer_details.fullname || '-');
      // Campaign Details
      contractTemplate.content[4].table.body[1][0].text = this.influencerContract.brief.campaignName;
      // contractTemplate.content[4].table.body[2][0].text = `Campaign Period: ${this.dateFormat(this.influencerContract.brief.startDate)} - ${this.dateFormat(this.influencerContract.brief.endDate)}`;
      contractTemplate.content[4].table.body[2][0].text = 'Campaign Ref: ' + this.influencerContract.campaignID;
      // DELIVERABLES
      tableBody.push([{text: 'DESCRIPTION', style: 'tableHeader', alignment: 'center'}, {text: 'QTY', style: 'tableHeader', alignment: 'center'}, {text: 'AMOUNT', style: 'tableHeader', alignment: 'center'}]);
      if (this.influencerContract.deliverables.no_of_stories) {
        tableBody.push(['IG Story', {text: this.influencerContract.deliverables.no_of_stories, alignment: 'center'},
        // {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center'},
        (this.checkShowAmountRowSpan('no_of_stories') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
        ]);
      }
      if (this.influencerContract.deliverables.no_of_xhs_posts) {
        tableBody.push(['XHS Post', {text: this.influencerContract.deliverables.no_of_xhs_posts, alignment: 'center'},
        // {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center'},
        (this.checkShowAmountRowSpan('no_of_xhs_posts') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
        ]);
      }
      if (this.influencerContract.deliverables.no_of_fb_posts) {
        tableBody.push(['FB Post', {text: this.influencerContract.deliverables.no_of_fb_posts, alignment: 'center'},
        // {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center'},
        (this.checkShowAmountRowSpan('no_of_fb_posts') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
        ]);
      }
      if (this.influencerContract.deliverables.no_of_tiktok_posts) {
        tableBody.push(['TikTok Post', {text: this.influencerContract.deliverables.no_of_tiktok_posts, alignment: 'center'},
        // (!this.influencerContract.deliverables.no_of_tiktok_posts ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : ''),
        (this.checkShowAmountRowSpan('no_of_tiktok_posts') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
        ]);
      }
      if (this.influencerContract.deliverables.no_of_posts) {
        tableBody.push(['IG Post', {text: this.influencerContract.deliverables.no_of_posts, alignment: 'center'},
        // (!this.influencerContract.deliverables.no_of_stories ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : ''),
        (this.checkShowAmountRowSpan('no_of_posts') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
        ]);
      }
      if (this.influencerContract.deliverables.no_of_carousels) {
        tableBody.push(['IG Carousel', {text: this.influencerContract.deliverables.no_of_carousels, alignment: 'center'},
        // (!this.influencerContract.deliverables.no_of_posts && !this.influencerContract.deliverables.no_of_stories ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : ''),
        (this.checkShowAmountRowSpan('no_of_carousels') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
        ]);
      }
      if (this.influencerContract.deliverables.no_of_video > 0) {
        tableBody.push(['IG Video', {text: this.influencerContract.deliverables.no_of_video, alignment: 'center'},
        // (!this.influencerContract.deliverables.no_of_carousels && !this.influencerContract.deliverables.no_of_posts && !this.influencerContract.deliverables.no_of_stories ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : ''),
        (this.checkShowAmountRowSpan('no_of_video') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
        ]);
      }
      if (this.influencerContract.deliverables.no_of_igTv > 0) {
        tableBody.push(['IG TV', {text: this.influencerContract.deliverables.no_of_igTv, alignment: 'center'},
        // (!this.influencerContract.deliverables.no_of_video && !this.influencerContract.deliverables.no_of_carousels && !this.influencerContract.deliverables.no_of_posts && !this.influencerContract.deliverables.no_of_stories ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : ''),
        (this.checkShowAmountRowSpan('no_of_igTv') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
        ]);
      }
      if (this.influencerContract.deliverables.no_of_reels > 0) {
        tableBody.push(['IG Reel', {text: this.influencerContract.deliverables.no_of_reels, alignment: 'center'},
        // (!this.influencerContract.deliverables.no_of_video && !this.influencerContract.deliverables.no_of_carousels && !this.influencerContract.deliverables.no_of_posts && !this.influencerContract.deliverables.no_of_stories ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : ''),
        (this.checkShowAmountRowSpan('no_of_reels') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
        ]);
      }
      if (this.influencerContract.deliverables.no_of_li_posts) {
        tableBody.push(['LinkedIn Post', {text: this.influencerContract.deliverables.no_of_li_posts, alignment: 'center'},
        // {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center'},
        (this.checkShowAmountRowSpan('no_of_li_posts') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
        ]);
      }
      if (this.influencerContract.deliverables.no_of_x_posts) {
        tableBody.push(['X (Twitter) Post', {text: this.influencerContract.deliverables.no_of_x_posts, alignment: 'center'},
        (this.checkShowAmountRowSpan('no_of_x_posts') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
        ]);
      }
      if (this.influencerContract.deliverables.youtube > 0) {
        tableBody.push(['Youtube', {text: this.influencerContract.deliverables.youtube, alignment: 'center'},
        // (!this.influencerContract.deliverables.no_of_video && !this.influencerContract.deliverables.no_of_carousels && !this.influencerContract.deliverables.no_of_posts && !this.influencerContract.deliverables.no_of_stories ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : ''),
        (this.checkShowAmountRowSpan('youtube') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
        ]);
      }
      if (this.influencerContract.deliverables.loading_whitelisting) {
        tableBody.push(['Loading/Whitelisting', {text: this.influencerContract.deliverables.loading_whitelisting, alignment: 'center'},
        // (!this.influencerContract.deliverables.no_of_video && !this.influencerContract.deliverables.no_of_carousels && !this.influencerContract.deliverables.no_of_posts && !this.influencerContract.deliverables.no_of_stories ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : ''),
        (this.checkShowAmountRowSpan('loading_whitelisting') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
        ]);
      }
      if (this.influencerContract.deliverables.exclusivity) {
        tableBody.push(['Exclusivity', {text: this.influencerContract.deliverables.exclusivity, alignment: 'center'},
        // (!this.influencerContract.deliverables.no_of_video && !this.influencerContract.deliverables.no_of_carousels && !this.influencerContract.deliverables.no_of_posts && !this.influencerContract.deliverables.no_of_stories ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : ''),
        (this.checkShowAmountRowSpan('exclusivity') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
        ]);
      }
      if (this.influencerContract.deliverables.physical_attendance > 0) {
        tableBody.push(['Physical Attendance', {text: this.influencerContract.deliverables.physical_attendance, alignment: 'center'},
        // (!this.influencerContract.deliverables.no_of_video && !this.influencerContract.deliverables.no_of_carousels && !this.influencerContract.deliverables.no_of_posts && !this.influencerContract.deliverables.no_of_stories ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : ''),
        (this.checkShowAmountRowSpan('physical_attendance') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
        ]);
      }
      if (this.influencerContract.deliverables.online_attendance > 0) {
        tableBody.push(['Online Attendance', {text: this.influencerContract.deliverables.online_attendance, alignment: 'center'},
        // (!this.influencerContract.deliverables.no_of_video && !this.influencerContract.deliverables.no_of_carousels && !this.influencerContract.deliverables.no_of_posts && !this.influencerContract.deliverables.no_of_stories ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : ''),
        (this.checkShowAmountRowSpan('online_attendance') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
        ]);
      }
      if (this.influencerContract.deliverables.custom && this.influencerContract.deliverables.custom.length > 0) {
        let customDeliverables = this.influencerContract.deliverables.custom
        for (const [index, obj] of customDeliverables.entries()) {
          console.log(index)
          tableBody.push([obj.label, {text: obj.value, alignment: 'center'},
          (this.checkShowAmountRowSpan('custom') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')]);
        }
      }
      if (this.influencerContract.payout_details && this.influencerContract.payout_details.boostingFees && this.influencerContract.payout_details.boostingFees.length > 0) {
        let boostingFees = this.influencerContract.payout_details.boostingFees
        for (const [index, boostingFee] of boostingFees.entries()) {
          console.log(index)
          tableBody.push([{colSpan: 2, text: boostingFee.label}, '', {text: this.formatPayout(boostingFee.value), alignment: 'center'}]);
        }
      }
      if (this.influencerContract.GST) {
        tableBody.push(['GST', {text: 1, alignment: 'center'},
        // {rowSpan: 1, text: this.formatPayout(this.influencerContract.GSTpercent), alignment: 'center', margin: 10},
        {rowSpan: 1, text: this.formatPayout(this.influencerContract.GSTpercent), alignment: 'center', margin: 10}])
      }
      if (this.influencerContract.deliverableNotes) {
        tableBody.push([{colSpan: 3, text: this.influencerContract.deliverableNotes, alignment: 'left'}])
      }
      tableBody.push([{border: [false, true, false, false], text: ''}, {fillColor: '#3F3FFF', color: 'white', colSpan: 2, rowSpan: 1, text: `TOTAL: ${this.formatPayout(this.influencerContract.payout || 0)}`, alignment: 'center'}]);
      contractTemplate.content[5].table.body = tableBody;
      if (this.influencerContract.invoiceRemarks) {
        contractTemplate.content.splice(6, 0, {
          margin: [0, 20, 0, 0],
          table: {
            widths: ['100%'],
            body: [
              [{text: 'Remarks', style: 'tableHeader', alignment: 'left'}],
              [{text: this.influencerContract.invoiceRemarks, border: [true, true, true, true]}]
            ]
          }
        })
      }
      return contractTemplate
    },
    async saveContractInvoice() {
      // ANCHOR Becareful with the Sending email to influlcer in this section
      // console.log('Rowspan', this.getRowSpanCount)
      this.$emit('loadingDialogOpen')
      // check for influencer email Tiktok
      if (this.influencerEmail) {
        if (this.influencer.influencer_details.contact_details.email === undefined || !this.influencer.influencer_details.contact_details.email) {
          this.influencer.influencer_details.contact_details.email = this.influencerEmail
        }
      }
      let briefPdfData = null
      // if (!this.isDownload) {
      //   const htmlToPdf = new HTMLToPDF(this.briefDetailContent, 'Barlow')
      //   briefPdfData = await htmlToPdf.generate()
      // }

     /**
       * NOTE Update pairing model to add contract blocks
       */
      let data = {
        pairingID: this.influencer.id,
        userID: this.currentUser.id,
        content_contract: this.generateContract(),
        email_content: this.emailTemplateHTML
      }
      await pairingAPIs.addContracts(data)
      this.briefDetailSave(false)
      // /**
      //  * NOTE Update Status to Interested, Not Interested, Accepted, Not Accepted and send eamil to invluencer
      //  */
      await pairingAPIs.doAction(this.influencer.id, 'accepted')

      // convert contract to file for uploading in confirm payout
      let pdfDocGenerator = pdfMake.createPdf(data.content_contract)
      this.contractFile = await new Promise((resolve) => {
        pdfDocGenerator.getDataUrl((dataUrl) => {
          let response = utils.func.dataURLtoFile(dataUrl, 'invoice_contract.pdf')
          resolve(response)
        })
      })
      let coInfo = {
        'co_email': this.selectedUser.email,
        'co_name': `${this.selectedUser.firstName} ${this.selectedUser.lastName}`
      }
      let formData = new FormData();
      formData.append('pairedID', this.influencer.id)
      formData.append('template', config.sendGridTemplateIds.co_approve_influencer_for_campaign)
      formData.append('subject', `Next steps for ${this.influencer.CampaignName} Campaign!`)
      formData.append('influencer', JSON.stringify(this.influencer.influencer_details))
      formData.append('campaign_name', this.influencer.CampaignName)
      formData.append('co', JSON.stringify(coInfo))
      formData.append('emailBody', JSON.stringify(this.emailTemplateHTML))
      formData.append('submission_date', moment(this.submissionDate).format('DD/MM/yyyy'))
      formData.append('live_date', moment(this.liveDate).format('DD/MM/yyyy'))
      if (this.isDownload) {
        formData.append('updateSend', 1)
        if (this.isFinalPayout) {
          formData.append('finalPayout', 1)
        }
      } else {
        const htmlToPdf = new HTMLToPDF(this.briefDetailContent, 'Arial')
        briefPdfData = await htmlToPdf.generate()
        formData.append('brifeDetail', JSON.stringify(briefPdfData))
      }
      formData.append('contractFile', this.contractFile)
      await pairingAPIs.sendContractToInfluencer(formData)

      /**
       * NOTE Send Submission Draft Guide to Influencer
       */
      // let host = location.protocol + '//' + location.hostname + ':' + location.port;
      // let attachment = [
      //   {
      //     attachFile: {
      //       name: `${this.influencer.CampaignName}_Brief.pdf`,
      //       data: briefPdfData,
      //       type: 'blocks'
      //     }
      //   },
      //   {
      //     attachFile: {
      //       name: 'Kobe_IMS_Draft_Submission_Guide.pdf',
      //       data: 'draftSubmissionGuide',
      //       type: 'base64_content'
      //     }
      //   }
      // ]

      // let draftGuideParams = {
      //   influencerEmail: this.influencer.influencer_details.contact_details.email,
      //   templateId: config.SUBMIT_CONTENT_GUIDE_EMAIL_TEMPLATE_ID,
      //   dynamic_template_data: {
      //     campaignName: this.influencer.CampaignName,
      //     influencer: this.influencer.influencer_details.userHandle,
      //     co_name: `${this.currentUser.firstName} ${this.currentUser.lastName}`,
      //     submission_date: moment(this.submissionDate).format('DD/MM/yyyy'),
      //     draft_submit_url: host + '/v2/submit-draft-post'
      //   },
      //   attachment,
      //   // brifeDetail: briefPdfData,
      //   cc: {
      //     'co_email': this.currentUser.email,
      //     'co_name': `${this.currentUser.firstName} ${this.currentUser.lastName}`
      //   },
      //   from: {
      //     'email': this.currentUser.email,
      //     'name': `${this.currentUser.firstName} ${this.currentUser.lastName}`
      //   }
      // }
      // // await postApi.sendSubmissionGuide(draftGuideParams)
      // await pairingAPIs.sendSubmissionGuide(draftGuideParams)
      this.$emit('loadInfluencer')
      this.close()
    },
    async approvedClick() {
      /**
       * Call below function to load Invluencer contract data
      */
      if (this.influencer.influencer_details.platform && this.influencer.influencer_details.platform === 'tiktok') {
        await this.viewInvitation(this.influencer.CampaignID, this.influencer.influencer_details.userHandle, 'tiktok')
      } else if (this.influencer.influencer_details.platform && this.influencer.influencer_details.platform === 'youtube') {
        await this.viewInvitation(this.influencer.CampaignID, this.influencer.influencer_details.userHandle, 'youtube')
      } else if (this.influencer.influencer_details.platform && this.influencer.influencer_details.platform === 'xiaohongshu') {
        await this.viewInvitation(this.influencer.CampaignID, this.influencer.influencer_details.userHandle, 'xiaohongshu')
      } else if (this.influencer.influencer_details.platform && this.influencer.influencer_details.platform === 'others') {
        await this.viewInvitation(this.influencer.CampaignID, this.influencer.influencer_details.userHandle, 'others')
      } else {
        await this.viewInvitation(this.influencer.CampaignID, this.influencer.influencer_details.userHandle, 'instagram')
      }
      if (this.influencerContract.notInvoked) {
        return false
      }
      if (!this.influencerContract.submission_date) {
        await this.checkSubmissionLiveDate('Submission', 'Please, Save the submission date before accepted.')
        return false
      }
      if (!this.checkDeliverables()) {
        return false;
      }
      // load editor and auto save brief details
      let vm = this
      this.selectedTab = 1
      setTimeout(() => {
        vm.briefSaveStatusId++
        vm.selectedTab = 0
      }, 1000)
      // Check Influencer registered in IMS or not?
      // if (!this.influencer.influencer_details.influencerID && this.influencer.influencer_details.platform !== 'tiktok') {
      //   await this.checkInfluencer()
      //   // console.log('Registered Influencer', registered)
      //   return false
      // }
      if (this.influencer.Users) {
        this.selectedUser = this.influencer.Users.length > 0 ? this.influencer.Users[0] : ''
      }
      this.invoiceContract = this.generateContract()
      this.showContractModal = true;
    },
    upatedApproved(email = null) {
      if (email) {
        this.influencerEmail = email
      }
      // console.log('Email template text', this.emailTemplateHTML)
      this.saveContractInvoice()
    },
    async notAccepted() {
      this.$emit('loadingDialogOpen')
      // NOTE Check Influencer registered in IMS or not?
      if (!this.influencer.influencer_details.influencerID) {
        await this.checkInfluencer()
        // console.log('Registered Influencer', registered)
        return false
      }
      // const confirmed = (status === 'not_accepted' ? await this.rejectionBox() : await this.acceptBox())
      const confirmed = await this.rejectionBox()
      if (!confirmed) {
        this.$emit('loadingDialogClose') // NOTE if cancel reject then loading should be done
        return;
      }
      /**
       * NOTE 1 This is updated influencer status to 'not_accepted' and send email to influencer
       */
      let data = {
        'pairedID': this.influencer.id,
        'template': config.sendGridTemplateIds.co_reject_influencer_for_campaign,
        // 'subject': 'Better Luck Next Time',
        'subject': `Sorry, we can't work together this time..`,
        'influencer_name': (this.influencer.influencer_details.fullname ? this.influencer.influencer_details.fullname : this.influencer.userHandle),
        'campaign_name': this.influencer.CampaignName,
        'status': this.pairingStatus.NOT_ACCEPTED.value,
        'email': this.influencer.influencer_details.contact_details.email,
        'co': {
          'co_email': this.currentUser.email,
          'co_name': `${this.currentUser.firstName} ${this.currentUser.lastName}`
        }
      }
      await pairingAPIs.updateStatusEmail(data)
      this.$emit('loadInfluencer')
      /**
       * END 1
       */
    },
    async rejectionBox() {
      const result = await this.$swal({
        title: 'Please confirm',
        text: 'Are you sure to reject this influencer?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Reject.'
      });
      return result.value;
    },
    async approveBox() {
      const result = await this.$swal({
        title: 'Please confirm',
        html: `<p>Would you like to see a preview of an influencer contract before you approve?</p>`,
        type: 'question',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#66BB6A',
        confirmButtonText: 'Yes, Show me a preview',
        cancelButtonText: 'No, Approve & Send'
      });
      return result;
    },
    async checkInfluencer() {
      const result = await this.$swal({
        title: 'Not Registered',
        text: 'This influencer is not resgistered in IMS.',
        type: 'warning',
        confirmButtonText: 'Ok'
      });
      return result;
    },
    async checkSubmissionLiveDate(title, text) {
      const result = await this.$swal({
        title,
        text,
        type: 'warning',
        confirmButtonText: 'Ok'
      });
      return result;
    },
    async checkEditorContentSaved() {
      const result = await this.$swal({
        title: 'Brief Detail',
        text: 'Your brief detail is not saved.!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonColor: '#d33'
      });
      return result.value;
    },
    closeInfluencerContractModal() {
      this.showContractModal = false;
    },
    reloadDataTable() {
      this.$emit('reRenderDatTable')
    },
    dateFormat(date) {
      return moment(date).format('DD/MM/yyyy')
    },
    // NOTE add contentChangeTrue and contentChangeFalse to chenc brief detial save before accepted influencer
    contentChangeTrue() {
      this.editorContentChange = true;
    },
    contentChangeFalse() {
      this.editorContentChange = false;
    },
    generateEmailTempate() {
      let emailTemplate = '<p>Hello <b>{{influencer_name}}</b>,</p>\nStoked to have you on board for this campaign! <br/><p>Your Date of Submission: <b>{{submission_date}}</b></p><br/><p>It is important to read through the campaign brief before executing your campaign, do ensure you take backup photos to avoid any possible reshoots or revisions to save you time and effort.</p><p>You will find 3 documents attached below:\nInvoice\nCampaign Brief Document\nPlatform Guide on Onboarding <a href="https://drive.google.com/file/d/1w51Oaa_UZt7jTWmgJC-biPuT8dTN7IET/view?usp=sharing">here</a></p><br/><br/><p>Do you have any questions about the campaign brief or the submission date?\nYou can reach me at <b>{{co_email}}</b> for any urgent matters, Looking forward to your seeing your content!</p><br/>Cheers'
      this.emailTemplateView.influencer_name = this.influencer.influencer_details.fullname
      this.emailTemplateView.submission_date = moment(this.submissionDate).format('DD/MM/yyyy')
      // this.emailTemplateView.live_date = moment(this.liveDate).format('DD/MM/yyyy')
      this.emailTemplateView.co_email = this.currentUser.email
      let html = mustache.render(emailTemplate, this.emailTemplateView)
      this.emailTemplateHTML = html
    },
    async closeModel() {
      if (this.editorContentChange) {
        let checked = await this.checkEditorContentSaved()
        if (!checked) {
          return false
        }
      }
      this.reloadDataTable()
      this.close()
      this.tabShow = false
    },
    async updateSubmission(successMsg = true) {
      if (!this.submissionDate) {
        this.$swal({
          type: 'error',
          text: 'Please Select Submission Date.'
        });
        return false;
      }
      // Check if any boosting fees label is empty
      if (this.influencer.payout_details && this.influencer.payout_details.boostingFees && Array.isArray(this.influencer.payout_details.boostingFees)) {
        for (let boostingFee of this.influencer.payout_details.boostingFees) {
          if (!boostingFee.label || boostingFee.label.trim() === '') {
            this.$swal({
              type: 'warning',
              text: 'Please enter additional line item description'
            });
            return false;
          }
        }
      }
      if (this.influencer.influencer_details.platform && this.influencer.influencer_details.platform === 'tiktok') {
        await this.viewInvitation(this.influencer.CampaignID, this.influencer.influencer_details.userHandle, 'tiktok')
      } else if (this.influencer.influencer_details.platform && this.influencer.influencer_details.platform === 'youtube') {
        await this.viewInvitation(this.influencer.CampaignID, this.influencer.influencer_details.userHandle, 'youtube')
      } else if (this.influencer.influencer_details.platform && this.influencer.influencer_details.platform === 'xiaohongshu') {
        await this.viewInvitation(this.influencer.CampaignID, this.influencer.influencer_details.userHandle, 'xiaohongshu')
      } else if (this.influencer.influencer_details.platform && this.influencer.influencer_details.platform === 'facebook') {
        await this.viewInvitation(this.influencer.CampaignID, this.influencer.influencer_details.userHandle, 'facebook')
      } else if (this.influencer.influencer_details.platform && this.influencer.influencer_details.platform === 'others') {
        await this.viewInvitation(this.influencer.CampaignID, this.influencer.influencer_details.userHandle, 'others')
      } else {
        await this.viewInvitation(this.influencer.CampaignID, this.influencer.influencer_details.userHandle, 'instagram')
      }
      if (this.influencer.payout_details) {
        if (this.influencer.payout_details.amount) {
          this.influencer.payout_details.amount = Number(this.totalPayout)
        }
      }
      let deliverablesDetails = this.getDeliverablesForSave(this.influencerContract.deliverables)
      let payoutDetails = this.getPayoutDetailsForSave(this.influencerContract.payout_details)
      this.syncEditedInvoiceToContract(deliverablesDetails, payoutDetails)
      this.invoiceContract = this.generateContract()
      let pdfDocGenerator = pdfMake.createPdf(this.invoiceContract)
      this.contractFile = await new Promise((resolve) => {
        pdfDocGenerator.getDataUrl((dataUrl) => {
          let response = utils.func.dataURLtoFile(dataUrl, 'invoice_contract.pdf')
          resolve(response)
        })
      })
      let formData = new FormData();
      formData.append('pairingID', this.influencer.id)
      formData.append('submissionDate', moment(this.submissionDate).format('YYYY-MM-DD'))
      formData.append('liveDate', new Date(this.liveDate))
      formData.append('GST', this.chkGST)
      formData.append('SpecialPaymentTerms', this.chkSpecialPaymentTerms)
      formData.append('deliverableNotes', this.deliverableNotes)
      formData.append('invoiceRemarks', this.invoiceRemarks)
      formData.append('contractFile', this.contractFile)
      formData.append('deliverablesDetails', JSON.stringify(deliverablesDetails))
      formData.append('payoutDetails', JSON.stringify(payoutDetails))
      await pairingAPIs.updateSubmissionAndLiveDates(formData)
      let params = {
        pairingID: this.influencer.id,
        submissionDate: moment(this.submissionDate).format('YYYY-MM-DD'),
        liveDate: new Date(this.liveDate),
        GST: this.chkGST,
        SpecialPaymentTerms: this.chkSpecialPaymentTerms,
        deliverableNotes: this.deliverableNotes,
        invoiceRemarks: this.invoiceRemarks,
        currency: this.currency,
        payoutDetails
      }
      // console.log('🚀 ~ file: InfluencerDetailViewModal.vue ~ line 734 ~ updateSubmission ~ params', params)
      let res = await pairingAPIs.updateGSTamount(params)
      if (res.status === 200) {
        this.$set(this.influencer, 'payout_details', utils.func.refreshJSON(payoutDetails))
        this.totalPayout = Number(payoutDetails.amount || 0)
        this.currentPayout = this.totalPayout
        this.influencer.payout = this.totalPayout
        this.oldPayoutDetails = Object.assign({}, JSON.parse(JSON.stringify(payoutDetails)))
        this.generateEmailTempate()
        if (successMsg) {
          this.snackbarText = 'Successfully, Saved!'
          this.snackbar = true
        }
        this.$emit('reRenderDatTable')
      }
      return true
      // console.log('🚀 ~ file: InfluencerDetailViewModal.vue ~ line 737 ~ updateSubmission ~ response', response)
    },
    async updateSend() {
      this.downloadloading = true
      /**
       * Call below function to load influencer Contract data
      */
      if (this.influencer.influencer_details.platform && this.influencer.influencer_details.platform === 'tiktok') {
        await this.viewInvitation(this.influencer.CampaignID, this.influencer.influencer_details.userHandle, 'tiktok')
      } else if (this.influencer.influencer_details.platform && this.influencer.influencer_details.platform === 'youtube') {
        await this.viewInvitation(this.influencer.CampaignID, this.influencer.influencer_details.userHandle, 'youtube')
      } else if (this.influencer.influencer_details.platform && this.influencer.influencer_details.platform === 'xiaohongshu') {
        await this.viewInvitation(this.influencer.CampaignID, this.influencer.influencer_details.userHandle, 'xiaohongshu')
      } else if (this.influencer.influencer_details.platform && this.influencer.influencer_details.platform === 'facebook') {
        await this.viewInvitation(this.influencer.CampaignID, this.influencer.influencer_details.userHandle, 'facebook')
      } else if (this.influencer.influencer_details.platform && this.influencer.influencer_details.platform === 'others') {
        await this.viewInvitation(this.influencer.CampaignID, this.influencer.influencer_details.userHandle, 'others')
      } else {
        await this.viewInvitation(this.influencer.CampaignID, this.influencer.influencer_details.userHandle, 'instagram')
      }
      if (!this.checkDeliverables()) {
        return false;
      }
      this.invoiceContract = this.generateContract()
      if (!this.invoiceContract) {
        return false
      }
      // pdfMake.createPdf(this.invoiceContract).download(this.reportName + 'invoice.pdf');
      // const blocksToPdf = new BlocksToPDF(this.briefDetailContent.blocks, 'Barlow')
      // let pdfData = await blocksToPdf.generate()
      // let pdfDocGenerator = pdfMake.createPdf(pdfData)
      // pdfDocGenerator.download(this.reportName + 'brief.pdf');
      // update contract without sending email
      this.saveContractInvoice()
    },
    async getInvoiceContract() {
      if (this.influencer.influencer_details.platform && this.influencer.influencer_details.platform === 'tiktok') {
        await this.viewInvitation(this.influencer.CampaignID, this.influencer.influencer_details.userHandle, 'tiktok')
      } else if (this.influencer.influencer_details.platform && this.influencer.influencer_details.platform === 'youtube') {
        await this.viewInvitation(this.influencer.CampaignID, this.influencer.influencer_details.userHandle, 'youtube')
      } else if (this.influencer.influencer_details.platform && this.influencer.influencer_details.platform === 'xiaohongshu') {
        await this.viewInvitation(this.influencer.CampaignID, this.influencer.influencer_details.userHandle, 'xiaohongshu')
      } else if (this.influencer.influencer_details.platform && this.influencer.influencer_details.platform === 'facebook') {
        await this.viewInvitation(this.influencer.CampaignID, this.influencer.influencer_details.userHandle, 'facebook')
      } else if (this.influencer.influencer_details.platform && this.influencer.influencer_details.platform === 'others') {
        await this.viewInvitation(this.influencer.CampaignID, this.influencer.influencer_details.userHandle, 'others')
      } else {
        await this.viewInvitation(this.influencer.CampaignID, this.influencer.influencer_details.userHandle, 'instagram')
      }
      if (!this.checkDeliverables()) {
        return false;
      }
      this.invoiceContract = this.generateContract()
      // if (!this.invoiceContract) {
      //   return false
      // }
      // convert contract to file for uploading in confirm payout
      let pdfDocGenerator = pdfMake.createPdf(this.invoiceContract)
      this.contractFile = await new Promise((resolve) => {
        pdfDocGenerator.getDataUrl((dataUrl) => {
          let response = utils.func.dataURLtoFile(dataUrl, 'invoice_contract.pdf')
          resolve(response)
        })
      })
      return true
    },
    followUp() {
      this.showFollowUpModal = true
    },
    followUpClose() {
      this.showFollowUpModal = false
    },
    checkDeliverables() {
      if (this.influencerContract.deliverables === undefined) {
        this.$swal({
          type: 'error',
          text: 'Please submit deliverables to generate invoice.'
        });
        return false;
      }
      return true
    },
    async download() {
      this.loader = 'loading'
      const htmlToPdf = new HTMLToPDF(this.briefDetailContent, 'Arial')
      let pdfData = await htmlToPdf.generate()
      // // console.log('PDF Data', pdfData)
      pdfMake.createPdf(pdfData).download(this.reportName + 'brief.pdf');
      // let pdfData = htmlToPdfmake(this.briefDetailContent);
      // pdfMake.createPdf({content: pdfData, defaultStyle: {font: 'Barlow'}}).download(this.reportName + 'brief.pdf');
      this.loading = false
      this.loader = null
    },
    briefDetailSave(isSnackBar = true) {
      let data = {
        pairingID: this.influencer.id,
        userID: this.currentUser.id,
        contentHTML: this.briefDetailContentNew
      }
      pairingAPIs.updatePairingBriefDetails(data).then(() => {
        this.contentChangeFalse()
        // this.reloadDataTable()
      })
      if (isSnackBar) {
        this.snackbarText = 'Successfully, Saved!'
        this.snackbar = true
      }
    },
    changeBriefContent(content) {
      this.briefDetailContent = content
      this.briefDetailContentNew = content
      this.editorOpened = false
      this.contentChangeTrue()
    },
    changeEditorOpen() {
      this.editorOpened = false
    },
    focusBriefContent() {
      this.changeEditorOpen()
      this.contentChangeTrue()
    },
    loadingDialogOpen() {
      this.$emit('loadingDialogOpen')
    },
    loadingDialogClose() {
      this.$emit('loadingDialogClose')
    },
    async restoreCampaignBrief() {
      let blocks = await campaignHelper.generateBlocks(this.influencer)
      let blocksTohtml = new BlocksToHtml(blocks)
      this.briefDetailContent = blocksTohtml.generate(false)
    },
    checkShowAmountRowSpan(type) {
      if (!this.showAmountRowSpan) {
        this.showAmountRowSpan = type
        return true
      } else if (this.showAmountRowSpan === type) return true
      return false
    },
    ensureDeliverables(defaultDeliverables = {}) {
      if (!this.influencer.deliverables) {
        this.$set(this.influencer, 'deliverables', utils.func.refreshJSON(defaultDeliverables || {}))
      }
      if (!Array.isArray(this.influencer.deliverables.custom)) {
        this.$set(this.influencer.deliverables, 'custom', [])
      }
      return this.influencer.deliverables
    },
    ensurePayoutDetails(defaultPayoutDetails = {}) {
      if (!this.influencer.payout_details) {
        this.$set(this.influencer, 'payout_details', utils.func.refreshJSON(defaultPayoutDetails || {}))
      }
      if (!Array.isArray(this.influencer.payout_details.boostingFees)) {
        this.$set(this.influencer.payout_details, 'boostingFees', [])
      }
      return this.influencer.payout_details
    },
    getDeliverablesForSave(defaultDeliverables = {}) {
      let deliverables = utils.func.refreshJSON(this.ensureDeliverables(defaultDeliverables))
      deliverables.custom = (deliverables.custom || []).filter(custom => custom && custom.label)
      return deliverables
    },
    getPayoutDetailsForSave(defaultPayoutDetails = {}) {
      let payoutDetails = utils.func.refreshJSON(this.ensurePayoutDetails(defaultPayoutDetails))
      payoutDetails.boostingFees = (payoutDetails.boostingFees || []).filter(boostingFee => boostingFee && boostingFee.label)
      payoutDetails.currency = this.currency
      return this.normalizePayoutDetailsForSave(payoutDetails)
    },
    parsePayoutAmount(value) {
      const amount = Number(value)
      return isNaN(amount) ? 0 : amount
    },
    getBoostingFeesTotal(boostingFees) {
      if (!Array.isArray(boostingFees)) return 0
      return boostingFees.reduce((total, boostingFee) => total + this.parsePayoutAmount(boostingFee && boostingFee.value), 0)
    },
    getPayoutOriginAmount(payoutDetails = {}) {
      if (payoutDetails.originAmount !== undefined && payoutDetails.originAmount !== null && payoutDetails.originAmount !== '') {
        return this.parsePayoutAmount(payoutDetails.originAmount)
      }
      const existingFees = this.getBoostingFeesTotal(this.oldPayoutDetails.boostingFees)
      const existingGST = this.parsePayoutAmount(this.oldPayoutDetails.GSTpercent)
      // Only prefer the last-loaded/saved payout_details.amount over this.currentPayout when
      // boosting fees actually changed - that's the specific case where this.currentPayout (a
      // client-side running total) can already reflect fees not yet recorded as originAmount,
      // and subtracting those fees back out of it would silently corrupt the real base paired
      // amount. When boosting fees are unchanged, this.currentPayout is trusted as-is so a
      // legitimate direct edit to the payout amount isn't discarded.
      const incomingFees = this.getBoostingFeesTotal(payoutDetails.boostingFees)
      if (incomingFees !== existingFees) {
        if (this.oldPayoutDetails.originAmount !== undefined && this.oldPayoutDetails.originAmount !== null && this.oldPayoutDetails.originAmount !== '') {
          return this.parsePayoutAmount(this.oldPayoutDetails.originAmount)
        }
        if (this.oldPayoutDetails.amount !== undefined && this.oldPayoutDetails.amount !== null && this.oldPayoutDetails.amount !== '') {
          return this.parsePayoutAmount(this.oldPayoutDetails.amount) - existingFees - existingGST
        }
      }
      return this.parsePayoutAmount(this.currentPayout) - existingFees - existingGST
    },
    normalizePayoutDetailsForSave(payoutDetails = {}) {
      const originAmount = this.getPayoutOriginAmount(payoutDetails)
      const subtotal = originAmount + this.getBoostingFeesTotal(payoutDetails.boostingFees)
      const GSTpercent = this.chkGST ? subtotal * 0.09 : 0
      payoutDetails.originAmount = parseFloat(originAmount || 0).toFixed(2)
      payoutDetails.amount = parseFloat((subtotal + GSTpercent) || 0).toFixed(2)
      payoutDetails.GSTpercent = GSTpercent > 0 ? parseFloat(GSTpercent).toFixed(2) : 0
      return payoutDetails
    },
    syncEditedInvoiceToContract(deliverablesDetails = null, payoutDetails = null) {
      if (!this.influencerContract || this.influencerContract.notInvoked) {
        return
      }
      if (this.influencer.deliverables || deliverablesDetails) {
        this.influencerContract.deliverables = deliverablesDetails || this.getDeliverablesForSave()
      }
      if (this.influencer.payout_details || payoutDetails) {
        this.influencerContract.payout_details = payoutDetails || this.getPayoutDetailsForSave()
      }
      this.influencerContract.GST = this.chkGST
      this.influencerContract.SpecialPaymentTerms = this.chkSpecialPaymentTerms
      this.influencerContract.deliverableNotes = this.deliverableNotes
      this.influencerContract.invoiceRemarks = this.invoiceRemarks
      this.influencerContract.currency = this.currency
      if (payoutDetails && payoutDetails.amount !== undefined && payoutDetails.amount !== null && payoutDetails.amount !== '') {
        this.influencerContract.payout = Number(payoutDetails.amount)
        this.influencerContract.GSTpercent = payoutDetails.GSTpercent
      } else if (this.totalPayout !== undefined && this.totalPayout !== null && this.totalPayout !== '') {
        this.influencerContract.payout = Number(this.totalPayout)
      }
    },
    addCustom() {
      this.ensureDeliverables().custom.push({
        label: '',
        value: ''
      })
    },
    addBoostingFee() {
      this.ensurePayoutDetails().boostingFees.push({
        label: '',
        value: ''
      })
    },
    updateTotalPayoutWithBoostingFee() {
      const payoutDetails = this.ensurePayoutDetails()
      const feeAmount = this.getBoostingFeesTotal(payoutDetails.boostingFees)
      const originAmount = this.getPayoutOriginAmount(payoutDetails)
      const GSTpercent = this.chkGST ? (originAmount + feeAmount) * 0.09 : 0
      this.totalPayout = Number(parseFloat(originAmount + feeAmount + GSTpercent).toFixed(2))
    },
    deleteBoostingFees(bIndex) {
      this.influencer.payout_details.boostingFees.splice(bIndex, 1)
      let vm = this
      setTimeout(() => {
        vm.updateTotalPayoutWithBoostingFee(0)
      }, 500) 
    }
  }
};
</script>



// WEBPACK FOOTER //
// InfluencerDetailViewModal.vue?41aef523